
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 139 69.098"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#06c","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M28.542 24.7a116.572 116.572 0 00-12.862-1.2q-3.671 0-4.746.677a2.352 2.352 0 00-1.074 2.142 2.04 2.04 0 001.446 2.032 55.742 55.742 0 007.413 1.656q5.967 1.092 8.489 3.575t2.521 8.055q0 12.2-14.9 12.195a63.78 63.78 0 01-11.864-1.355l-2.372-.452.3-8.43a116.258 116.258 0 0012.788 1.2 11.347 11.347 0 004.893-.714 2.311 2.311 0 001.3-2.146 2.22 2.22 0 00-1.374-2.104 34.956 34.956 0 00-7.117-1.657q-5.749-.976-8.566-3.312T0 26.544q0-5.982 4-9.033a16.528 16.528 0 0110.308-3.049 68.307 68.307 0 0111.935 1.431l2.447.451zM36.96 69.098V15.37h10.108v2.044q4.94-2.952 8.665-2.952 7.675 0 11.324 4.579t3.649 15.55q0 10.974-4.029 15.248t-13.225 4.275a34.856 34.856 0 01-5.4-.454l-.912-.152v15.59zm16.8-45.555a15.513 15.513 0 00-5.7 1.135l-.912.378v19.827a44.126 44.126 0 005.548.454q4.407 0 6.043-2.573t1.634-8.778q0-10.442-6.613-10.443zM139 0v52.924h-10v-1.587a21.937 21.937 0 01-9.093 2.5q-8.194 0-11.424-4.763t-3.229-15.089q0-10.32 3.871-15.046t11.687-4.725a41.244 41.244 0 016.689.756l1.428.3V0zm-11.124 43.852l1.053-.226V23.741a41.461 41.461 0 00-7.366-.756q-6.087 0-6.087 10.887 0 5.9 1.352 8.392a4.69 4.69 0 004.472 2.5 25.9 25.9 0 006.576-.908zM88.481 36.96a9.979 9.979 0 01-7.571-3.134 10.836 10.836 0 01-2.974-7.771 10.7 10.7 0 012.956-7.714 10.037 10.037 0 017.566-3.075 9.662 9.662 0 017.484 3.149 11.1 11.1 0 012.883 7.774 10.819 10.819 0 01-2.883 7.7 9.751 9.751 0 01-7.462 3.074M77.936 52.891a11.2 11.2 0 012.956-7.945 9.893 9.893 0 017.566-3.166 9.532 9.532 0 017.485 3.241 11.636 11.636 0 012.883 8.008"}})])])
          )
        }
      }
    